<template>
  <div id="app" :class="{ 'with-bottom-nav': showBottomNav }">
    <!-- AI智能体图标组件，仅登录后显示 -->
    <!-- <AIAgentIcon /> -->
    <keep-alive :include="['Explore']">
      <router-view />
    </keep-alive>
    <BottomNav v-if="showBottomNav" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import BottomNav from './components/BottomNav.vue'
import AIAgentIcon from './components/AIAgentIcon.vue'

const route = useRoute()

const showBottomNav = computed(() => {
  const excludedPaths = ['/login', '/register', '/signin', '/login-page', '/shop', '/forgot-password', '/forget-password', '/nav-3d', '/profile-edit']
  const isExcludedPath = excludedPaths.some(path => route.path.startsWith(path)) ||
    route.path.startsWith('/chat/') ||
    route.name === 'Login' ||
    route.name === 'Register' ||
    route.name === 'ForgotPassword' ||
    route.name === 'Navigation3D' ||
    route.name === 'ProfileEdit'
  const is404 = route.name === 'NotFound'
  const isSharePreview = !!route.query.share_id
  // 试用模式（如 /companion-chat?mode=trial）隐藏底部导航
  const isTrialMode = route.query.mode === 'trial'

  console.log('当前路由路径:', route.path, '路由名称:', route.name, '是否显示底部导航:', !isExcludedPath && !is404 && !isSharePreview && !isTrialMode)

  return !isExcludedPath && !is404 && !isSharePreview && !isTrialMode
})
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  /* 优化字体栈，与全局样式保持一致 */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji', sans-serif;
  color: #2c3e50;
  line-height: 1.7;
  /* 字体平滑和抗锯齿 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* 优化字体渲染 */
  text-rendering: optimizeLegibility;
  -webkit-text-size-adjust: 100%;
  font-size: 16px;
}

#app {
  min-height: 100vh;
  padding-bottom: 20px;
}

#app.with-bottom-nav {
  padding-bottom: 20px;
}

/* 优化标题字体 */
h1, h2, h3, h4, h5, h6 {
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 0.5em;
  color: #1a1a1a;
}

/* 优化链接样式 */
a {
  color: #409EFF;
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: #66b1ff;
  text-decoration: underline;
}

/* 优化文本选择样式 */
::selection {
  background-color: rgba(64, 158, 255, 0.2);
  color: #2c3e50;
}
</style>
